var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTbm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3179 30.6219C23.6021 30.6219 30.3179 23.9062 30.3179 15.6219C30.3179 7.33768 23.6021 0.621948 15.3179 0.621948C7.0336 0.621948 0.317871 7.33768 0.317871 15.6219C0.317871 23.9062 7.0336 30.6219 15.3179 30.6219Z",
    fill: "#F4F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8632 22.662H8.77283C8.6396 22.662 8.51129 22.611 8.41443 22.5195C8.31757 22.4281 8.25949 22.303 8.25183 22.17L7.67273 12.338C7.66865 12.267 7.67917 12.196 7.70349 12.1291C7.72782 12.0623 7.76557 12.0011 7.81433 11.9494C7.8631 11.8976 7.92193 11.8564 7.98719 11.8281C8.05244 11.7998 8.12262 11.7852 8.19373 11.785H22.4418C22.5129 11.785 22.5835 11.7996 22.6488 11.8278C22.7141 11.856 22.7729 11.8973 22.8217 11.9491C22.8705 12.0009 22.9082 12.0621 22.9325 12.129C22.9568 12.1959 22.967 12.267 22.9628 12.338L22.3851 22.17C22.377 22.303 22.318 22.4279 22.2211 22.5193C22.1241 22.6107 21.9964 22.6618 21.8632 22.662Z",
    stroke: "#464646",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3181 17.221C16.2896 17.221 17.0771 16.4335 17.0771 15.462C17.0771 14.4905 16.2896 13.703 15.3181 13.703C14.3466 13.703 13.5591 14.4905 13.5591 15.462C13.5591 16.4335 14.3466 17.221 15.3181 17.221Z",
    stroke: "#EB008B",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8882 21.6999V19.8249C18.8668 19.4537 18.6993 19.1061 18.4224 18.858C18.1454 18.61 17.7815 18.4816 17.4102 18.5009H13.2261C12.8548 18.4818 12.4912 18.6103 12.2144 18.8583C11.9375 19.1064 11.7697 19.4538 11.748 19.8249V21.6999",
    stroke: "#EB008B",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87988 10.184H20.7559",
    stroke: "#464646",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9351 8.58398H17.7021",
    stroke: "#464646",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTbm);
export default __webpack_public_path__ + "static/media/icon-tbm.b453a6a283ab61b99ad9e766f14a7d5f.svg";
export { ForwardRef as ReactComponent };